function showSpinner($widget: JQuery): void {
    $widget.find(".js-membership-spinner").show();
}

function hideSpinner($widget: JQuery): void {
    $widget.find(".js-membership-spinner").hide();
}

interface AddMembershipToCartResponse {
    success: boolean;
    isMember: boolean;
    icon?: string;
    originalPrice?: number;
    itemAddedToCart: SaCartUtils.CartItemResponse;
}

function addMembershipToCart(addToCartButtonElement: HTMLElement): void {
    const $btn = $(addToCartButtonElement);
    if ($btn.prop("disabled")) {
        return;
    }

    const $widget = $btn.closest(".wMembershipLander__Marker");

    const productId = $widget.data("productid") as number;
    const productName =
        SaStringUtils.coerceToNullableString($widget.data("product-name")) ??
        "";
    const fallbackPrice = SaNumberUtils.coerceToFloat($widget.data("price"));
    const quantity = 1;

    $btn.prop("disabled", true);
    showSpinner($widget);

    $.ajax({
        type: "post",
        url: "/api/Cart/AddMembership",
        contentType: "application/json",
        success: function (data: AddMembershipToCartResponse) {
            if (data?.success && data.itemAddedToCart) {
                const dataLayerItem: SaAnalyticsUtils.DataLayerCheckoutItem = {
                    item_id: String(productId),
                    item_language: undefined,
                    price: data.itemAddedToCart.price,
                    item_name: productName,
                    quantity: quantity,
                };
                SaAnalyticsUtils.addToDataLayer(
                    SaAnalyticsUtils.buildAddToCartEventFromItems([
                        dataLayerItem,
                    ]),
                );

                SaCartUtils.showCartPopup(
                    data.itemAddedToCart.description,
                    data.isMember,
                    data.itemAddedToCart.price,
                    data.originalPrice ?? fallbackPrice,
                    data.icon ?? "",
                    data.itemAddedToCart,
                    {
                        showPriceDescription: false,
                        showQuantityControls: false,
                    },
                );
            } else {
                SaAlertUtils.defaultFire(
                    "Add to Cart Error",
                    "Unable to add membership to your cart. Please try again later.",
                );
            }
        },
        error: function (xhr: JQueryXHR) {
            SaAlertUtils.defaultFireFromResponse("Add to Cart Error", xhr);
        },
        complete: function () {
            hideSpinner($widget);
            $btn.prop("disabled", false);
        },
    });
}

export function listenForClicksOnAddToCartButtons(): void {
    $(".js-membership-buy-now").on("click", function (evt) {
        evt.preventDefault();
        addMembershipToCart(this);
    });
}

if (!SaNavigationUtils.NodeEnv.isTest()) {
    $(listenForClicksOnAddToCartButtons);
}
